import React, { Component } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { connect } from 'react-redux';
import LoadingComponent from '../../components/common/LoadingComponent';
import NewBenefitsCard from '../../components/policy/newBenefitsCard';
import { BoldText, Text, SemiBoldText } from '../../components/common/Text';
import NewClaimsCard from '../../components/policy/NewClaimsCard';
import { FadeInTransition } from '../../components/transitions/transitions';
import NewHelpCard from '../../components/policy/NewHelpCard';
import HospitalizationModal from '../../containers/common/HospitalizationModal';
import {
  InsureTabApi,
  InsureTabIpdBenefits,
  InsureTabOpdBenefits,
} from '../../services';
import { Carousel } from 'react-responsive-carousel';
import arrowLeft from '../../images/common/arrow-left.svg';
// import eyeIcon from '../../images/policy/eye_icon.svg'
import Tappable from 'react-tappable/lib/Tappable';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import EyeIcon from '../../images/newInsurerPage/eyeIcon.svg';
import WalletCardBackground1 from '../../images/newInsurerPage/walletBackground1.svg';
import WalletCardBackground2 from '../../images/newInsurerPage/walletBackground2.svg';
import WalletCardBackground3 from '../../images/newInsurerPage/walletBackground3.svg';
import HospitalCardBg from '../../images/newInsurerPage/HospitalCardBg.svg';
import HospitalCardArrow from '../../images/newInsurerPage/hospitalizationCardArrow.svg';
import PurpleDownArrow from '../../images/policy/purpleArrowDown.svg';
import BlueDownArrow from '../../images/policy/blueArrowDown.svg';
import GreenDownArrow from '../../images/policy/greenArrowDown.svg';
import Modal from '../../containers/common/Modal';
import NewHealthBenefitsCard from '../../components/policy/NewHealthBenefitsCard';
import DownArrowIcon from '../../images/policy/down-arrow.png';
import { openFileViewer } from '../../actions';

const OuterContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: stretch;
  height: 100svh;
  background: #ffffff;
  overflow: hidden;
  @media (min-width: 768px) {
    height: 90vh;
  }
`;

const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overflow-x: hidden;
  background: white;
`;

const Body = styled.div`
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  align-items: stretch;
  padding-bottom: 2rem;
  overflow-x: hidden;
`;

const HeaderContainer = styled.div`
  z-index: 10;
  align-self: stretch;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #f0f3f6;
  padding: 16px;
  width: 100%;
`;
const BenefitsDocLinkContainer = styled.div`
  font-family: var(--font-secondary);
  font-size: 14px;
  color: #0f0b28;
  align-items: center;
  border: 1px solid #e6e9ec;
  border-radius: 20px;
  display: flex;
  justify-content: center;
  cursor: pointer;
  margin-right: 1rem;
  margin-left: 1rem;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
`;

const HeaderText = styled(BoldText)`
  font-size: 16px;
  text-align: center;

  font-weight: 600;
`;
const SectionHeading = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 140%;
  margin-bottom: 1rem;
`;
const Session = styled.div`
  width: 90%;
  margin: auto;
  //margin-top: 1rem;
  //margin-bottom: 1rem;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-bottom: 2px solid #e6e9ec;
`;
const BackContainer = styled(Tappable)`
  //   margin-right: 0.5rem;

  display: flex;
  width: 44px;
  align-items: center;
  justify-content: center;
  &.Tappable-active {
    opacity: 0.2;
  }
`;

const HeaderTitleContainer = styled.div`
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
`;

const HospitalizationModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  height: 100svh;
  width: 100vw;
`;

const HospitalCardBenefits = styled.div`
  column-gap: 15px;
  display: flex;
  padding: 1rem;
  margin-top: 1rem;
  border-radius: 1rem;
`;
const BenefitsImageContainer = styled.div`
  width: 40px;
  max-width: 15%;
`;
const HospitalBenefitsTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
`;
const TitleText = styled.p`
  color: var(--primary-text-new, #0f0b28);

  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
`;
const DescriptionText = styled.p`
  color: #717171;

  font-size: 12px;
  font-weight: 500;
  line-height: 150%; /* 18px */
  text-transform: capitalize;
`;

const HospitalCardTappable = styled(Tappable)`
  &.Tappable-active {
    opacity: 0.2;
  }
`;
const HospitalCard = styled.div`
  background: ${(props) => `url(${props.bgSvg})`},
    ${(props) => `${props.bgColor}`};
  border-radius: 12px;
  border: 1px solid rgba(113, 79, 255, 0.11);
  display: flex;
  flex-direction: column;
`;
const HospitalCardTitle = styled.div`
  color: #15006b;
  font-feature-settings: 'clig' off, 'liga' off;

  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */
`;
const HospitalCardWrapper = styled.div`
  padding: 1rem;
  display: flex;
  flex-direction: column;
  row-gap: 35px;
`;
const HospitalInnerDiv = styled.div`
  display: flex;
  justify-content: space-between;
`;
const HospitalCardDescription = styled.p`
  color: #15006b;
  font-family: var(--font-secondary);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  width: 200px;
`;
const HospitalCardButton = styled.div`
  display: flex;
  background: white;
  border-radius: 5px;
  width: 100px;
`;
const HospitalCardButtonText = styled.div`
  display: flex;
  color: #15006b;
  font-feature-settings: 'clig' off, 'liga' off;

  font-size: 10px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%; /* 15px */
  width: 100%;
  align-items: center;
  justify-content: center;
`;
const CardDiv = styled.div`
  display: flex;
  flex-direction: column;
  border: 2px solid #d9d9d9;
  border-radius: 20px;
  margin-right: 1rem;
  margin-left: 1rem;
`;
const CardHeader = styled.div`
  display: flex;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  justify-content: space-between;
  align-items: center;
  background: #f5f4ff;
  border-top-right-radius: 20px;
  border-top-left-radius: 20px;
`;
const CardData = styled.div`
  display: flex;
  justify-content: space-between;
  width: 85%;
  margin: auto;
  padding-top: 1rem;
  padding-bottom: 0.7rem;
  border-bottom: 1px solid #e6e9ec;
`;

const CardInsurerLogoContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 55px;
  height: 55px;
`;
const CardSponsorLogoContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  gap: 5px;
  width: 80px;
  //height: 45px;
`;
const CardFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  align-items: center;
  background: #fff;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
`;
const CardTitle = styled.p`
  font-size: 16px;
  font-weight: 700;
  line-height: 140%;
`;
const CardPtag = styled.p`
  display: flex;
  align-items: center;
  color: #666;

  font-size: 10px;
  font-weight: 500;
  line-height: normal;
`;
const CardPtag2 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;

  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
`;
const CardPtag3 = styled.p`
  display: flex;
  align-items: center;
  color: #373737;
  text-align: right;

  font-size: 12px;
  font-weight: 600;
  line-height: 150%;
  padding: 0.5rem;
`;
const CarouselOuterContainer = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;
`;

class IpdBenefits extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      insured: false,
      opdPolicies: [],
      ipdPolicies: [],
      claims: [],
      opdWalletDetails: [],
      policyDetails: {},
      policySavings: {},
      reimbursementRequests: null,
      coiUrl: null,
      activeTabIndex: 0,
      activeTab: '',
      opdDependentWallet: [],
      dependentSelectedWallet: {},
      opdEcards: [],
      benefits: [],
      claimsSection: [],
      helpSection: [],
      offersSection: [],
      walletSection: [],
      currentOpenCard: null,
      healthBenefits: [],
      cards: [],
      hospitalCard: {},
      eCards: [],
      showHospitalizationModal: false,
      showCashlessClaimButton: true,
      showReimbusementClaimButton: true,
      showPendingHospilationBlocker: true,
      whatsappLogin: false,
      salientFeatureUrl: '',
    };
    const { state, search } = this.props.location;
    const searchParams = new URLSearchParams(search);
    const searchPolicyId = searchParams.get('policyId');
    const searchPolicyType = searchParams.get('policyType');

    this.policyId = state?.policyId || searchPolicyId;
    this.policyType = state?.policyType || searchPolicyType;
    this.policyNo = state?.policyNo;
    this.ecode = state?.ecode;

    if (this.searchPolicyId) this.state.whatsappLogin = true;
  }

  getAppropriateRoute(key) {
    switch (key) {
      case 'opd-policy-1':
        return this.props.history.push('home/insure/opd');
      case 'help':
        return this.props.history.push('/home/insure/faq');
      case 'gmc-policy':
        return;
      default:
        return '';
    }
  }
  hideModal = () => {
    this.setState({
      showRelativeModal: false,
      showHospitalizationModal: false,
    });
  };

  getBackground(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return WalletCardBackground1;
      case 1:
        return WalletCardBackground2;
      case 2:
        return WalletCardBackground3;
      default:
        return '';
    }
  }
  getBackgroundColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;

    switch (backgroundIndex) {
      case 0:
        return 'linear-gradient(132deg, rgba(249, 126, 124, 0.20) 0%, rgba(255, 109, 162, 0.10) 95.83%)';
      case 1:
        return 'linear-gradient(136deg, #C7EBFF 0%, rgba(211, 237, 255, 0.56) 91.69%)';
      case 2:
        return 'linear-gradient(151deg, rgba(146, 220, 70, 0.20) 0.01%, rgba(232, 228, 110, 0.20) 100%)';
      default:
        return '';
    }
  }
  getArrow(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return PurpleDownArrow;
      case 1:
        return BlueDownArrow;
      case 2:
        return GreenDownArrow;
      default:
        return '';
    }
  }
  getTextColor(index) {
    const backgroundIndex = Math.floor(index - 1) % 3;
    switch (backgroundIndex) {
      case 0:
        return '#E16262';
      case 1:
        return '#2E89BD';
      case 2:
        return '#90B529';
      default:
        return '';
    }
  }
  onCardTap(index) {
    if (this.state.currentOpenCard === index) {
      this.setState({ currentOpenCard: null });
    } else {
      this.setState({ currentOpenCard: index });
    }
  }
  handleSalientFeaturesFile = () => {
    const { salientFeatureUrl } = this.state;
    if (salientFeatureUrl) {
      this.downloadFile(salientFeatureUrl);
    } else {
      console.error('Salient feature URL not found');
    }
  };

  downloadFile = (url) => {
    // const userAgent = navigator.userAgent || navigator.vendor;
    // if (window.Android) {
    //   return window.open(url, '_blank');
    // } else if (window.webkit && window.webkit.messageHandlers.visitIosView) {
    //   window.webkit.messageHandlers.visitIosView.postMessage(
    //     JSON.stringify({
    //       method: 'openPDF',
    //       url: url,
    //     })
    //   );
    // } else if (/android/i.test(userAgent)) {
    //   const anchor = document.createElement('a');
    //   anchor.setAttribute('href', url);
    //   anchor.setAttribute('target', '_blank');
    //   anchor.click();
    //   return;
    // } else {
    //   const anchor = document.createElement('a');
    //   anchor.setAttribute('href', url);
    //   anchor.setAttribute('target', '_blank');
    //   anchor.click();
    // }
    this.props.openFileViewer({
      title: 'Prescription',
      contentUrl: url,
      type: 'pdf',
    });
  };

  async fetchData() {
    const { authToken } = this.props;
    try {
      if (!this.policyId) return;

      const response = await InsureTabIpdBenefits(
        authToken,
        this.policyId,
        this.policyType,
        this.policyNo,
        this.ecode
      );

      const ipdData = response;
      this.setState({
        eCards: ipdData.policyUsers,
        hospitalCard: ipdData.hospitalCard,
        benefits: ipdData.benefits,
        cards: ipdData.cards,
        showCashlessClaimButton:
          ipdData && ipdData?.basicDetails
            ? Boolean(ipdData.basicDetails.canIntimateClaimForPolicy)
            : true,
        showReimbusementClaimButton:
          ipdData && ipdData?.basicDetails
            ? Boolean(ipdData.basicDetails.canSubmitClaimForPolicy)
            : true,
        salientFeatureUrl: ipdData.salientFeatureUrl,
      });
    } catch (err) {
      console.log('err is', err);
    } finally {
      this.setState({ loading: false });
    }
  }

  componentDidMount() {
    if (this.props.loginState !== 'LOGGED_IN' || !this.props.authToken) {
      this.props.history.push('/');
    } else {
      //this.getConsults();
      this.fetchData();
    }
  }
  render() {
    const {
      whatsappLogin,
      eCards,
      loading,
      salientFeatureUrl,
      benefits,
      hospitalCard,
      cards,
      showHospitalizationModal,
      showReimbusementClaimButton,
      showPendingHospilationBlocker,
      showCashlessClaimButton,
    } = this.state;
    return (
      <OuterContainer>
        <HeaderContainer>
          <Header>
            {!whatsappLogin && (
              <BackContainer onTap={() => this.props.history.goBack()}>
                <img src={arrowLeft} alt="back" />{' '}
              </BackContainer>
            )}
            <HeaderText style={{ marginLeft: whatsappLogin ? '24px' : '0px' }}>
              IPD Benefits Details
            </HeaderText>
          </Header>
        </HeaderContainer>
        {loading ? (
          <LoadingComponent />
        ) : (
          <BodyContainer>
            <Body>
              {' '}
              <div>
                {eCards?.length > 1 ? (
                  <CarouselOuterContainer>
                    <Carousel
                      showIndicators={true}
                      showStatus={false}
                      centerMode={true}
                      centerSlidePercentage="90"
                    >
                      {eCards?.map((eCard) => {
                        return (
                          <CardDiv key={eCard.age}>
                            <CardHeader>
                              <CardInsurerLogoContainer>
                                <img src={eCard.insurerLogo} alt="" />
                              </CardInsurerLogoContainer>
                              <CardTitle>
                                {this?.policyType === 'gtl'
                                  ? 'GTL E-Card'
                                  : this?.policyType === 'gpa'
                                  ? 'GPA E-Card'
                                  : 'IPD E-Card'}
                              </CardTitle>
                            </CardHeader>
                            <CardData>
                              <CardPtag>Member Name</CardPtag>

                              <CardPtag2>{eCard.name}</CardPtag2>
                            </CardData>
                            <CardData>
                              <CardPtag>Age</CardPtag>

                              <CardPtag2>{eCard.age}</CardPtag2>
                            </CardData>
                            <CardData>
                              <CardPtag>Policy Number</CardPtag>

                              <CardPtag2>{eCard.policyNumber}</CardPtag2>
                            </CardData>
                            <CardData>
                              <CardPtag>Valid Till</CardPtag>

                              <CardPtag2>{eCard.validTill}</CardPtag2>
                            </CardData>
                            <CardFooter>
                              <CardSponsorLogoContainer>
                                <CardPtag>Corporate Name</CardPtag>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'left',
                                  }}
                                >
                                  <img
                                    src={eCard.sponsorLogo}
                                    style={{ width: '55%' }}
                                    alt=""
                                  />
                                </div>
                              </CardSponsorLogoContainer>
                              {(eCard.coiUrl || eCard.ecardUrl) && (
                                <CardPtag2>
                                  <div
                                    className="rounded-12 border mx-auto border-txtsecondary-shades7 hover text-center mr-12px flex flex-row items-center justify-center"
                                    onClick={() => {
                                      if (eCard.coiUrl) {
                                        this.downloadFile(eCard.coiUrl);
                                      } else {
                                        this.downloadFile(eCard.ecardUrl);
                                      }
                                    }}
                                    style={{ padding: '9px 2px 9px 4px' }}
                                  >
                                    <img
                                      src={DownArrowIcon}
                                      style={{
                                        marginRight: '6px',
                                        width: '7px',
                                        height: '8.33px',
                                        paddingTop: '1px',
                                      }}
                                      alt=""
                                    />
                                    <p
                                      className="text-chip font-semibold truncate p-1"
                                      style={{ color: '#301D66' }}
                                    >
                                      Download ECard
                                    </p>
                                  </div>
                                </CardPtag2>
                              )}
                            </CardFooter>
                          </CardDiv>
                        );
                      })}
                    </Carousel>
                  </CarouselOuterContainer>
                ) : (
                  <CarouselOuterContainer>
                    <Carousel
                      showIndicators={false}
                      showStatus={false}
                      centerMode={true}
                      centerSlidePercentage="100"
                    >
                      {eCards?.map((eCard) => {
                        return (
                          <CardDiv key={eCard.age}>
                            <CardHeader>
                              <CardInsurerLogoContainer>
                                <img src={eCard.insurerLogo} alt="" />
                              </CardInsurerLogoContainer>
                              <CardTitle>
                                {this.policyType === 'gtl'
                                  ? 'GTL E-Card'
                                  : this.policyType === 'gpa'
                                  ? 'GPA E-Card'
                                  : 'IPD E-Card'}
                              </CardTitle>
                            </CardHeader>
                            <CardData>
                              <CardPtag>Member Name</CardPtag>

                              <CardPtag2>{eCard.name}</CardPtag2>
                            </CardData>
                            <CardData>
                              <CardPtag>Age</CardPtag>

                              <CardPtag2>{eCard.age}</CardPtag2>
                            </CardData>
                            <CardData>
                              <CardPtag>Policy Number</CardPtag>

                              <CardPtag2>{eCard.policyNumber}</CardPtag2>
                            </CardData>
                            <CardData>
                              <CardPtag>Valid Till</CardPtag>

                              <CardPtag2>{eCard.validTill}</CardPtag2>
                            </CardData>
                            <CardFooter>
                              <CardSponsorLogoContainer>
                                <CardPtag>Corporate Name</CardPtag>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'left',
                                  }}
                                >
                                  <img
                                    src={eCard.sponsorLogo}
                                    style={{ width: '55%' }}
                                    alt=""
                                  />
                                </div>
                              </CardSponsorLogoContainer>
                              {(eCard.coiUrl || eCard.ecardUrl) && (
                                <CardPtag2>
                                  <div
                                    className="rounded-12 border mx-auto border-txtsecondary-shades7 hover text-center mr-12px flex flex-row items-center justify-center"
                                    onClick={() => {
                                      if (eCard.coiUrl) {
                                        this.downloadFile(eCard.coiUrl);
                                      } else {
                                        this.downloadFile(eCard.ecardUrl);
                                      }
                                    }}
                                    style={{ padding: '12px' }}
                                  >
                                    <img
                                      src={DownArrowIcon}
                                      style={{
                                        marginRight: '6px',
                                        width: '10px',
                                        height: '10px',
                                        paddingTop: '1px',
                                      }}
                                      alt=""
                                    />
                                    <p
                                      className="text-chip font-semibold truncate"
                                      style={{ color: '#301D66' }}
                                    >
                                      Download ECard
                                    </p>
                                  </div>
                                </CardPtag2>
                              )}
                            </CardFooter>
                          </CardDiv>
                        );
                      })}
                    </Carousel>
                  </CarouselOuterContainer>
                )}
                {salientFeatureUrl && (
                  <BenefitsDocLinkContainer
                    onClick={this.handleSalientFeaturesFile}
                  >
                    <img src={EyeIcon} alt="" />
                    <CardPtag3>View Policy Salient Features</CardPtag3>
                  </BenefitsDocLinkContainer>
                )}

                {(benefits?.length || hospitalCard) && (
                  <Session>
                    <SectionHeading>Health Benefits</SectionHeading>
                    {hospitalCard && (
                      <HospitalCardTappable
                        onTap={() =>
                          this.setState({ showHospitalizationModal: true })
                        }
                      >
                        <HospitalCard bgColor="#E3E0FF" bgSvg={HospitalCardBg}>
                          <HospitalCardWrapper>
                            <HospitalCardTitle>
                              {hospitalCard.label}
                            </HospitalCardTitle>
                            <HospitalInnerDiv>
                              <HospitalCardDescription>
                                {hospitalCard.description}
                              </HospitalCardDescription>
                              <HospitalCardButton>
                                <HospitalCardButtonText>
                                  <p>Add Request</p>{' '}
                                  <img src={HospitalCardArrow} alt="" />{' '}
                                </HospitalCardButtonText>
                              </HospitalCardButton>
                            </HospitalInnerDiv>
                          </HospitalCardWrapper>
                        </HospitalCard>
                      </HospitalCardTappable>
                    )}

                    {benefits?.map((item) => {
                      return (
                        <HospitalCardBenefits style={{ background: '#F5F4FF' }}>
                          <BenefitsImageContainer>
                            <img
                              src={item.icon}
                              width={'40px'}
                              height={'38px'}
                              alt=""
                            />
                          </BenefitsImageContainer>
                          <HospitalBenefitsTitleContainer>
                            <TitleText>{item.title}</TitleText>
                            <DescriptionText>
                              {item.description}
                            </DescriptionText>
                          </HospitalBenefitsTitleContainer>
                        </HospitalCardBenefits>
                      );
                    })}
                  </Session>
                )}

                {cards?.length > 0 && (
                  <Session>
                    <SectionHeading>Claims</SectionHeading>
                    {cards?.map((item) => {
                      if (item.key === 'claims')
                        return item.cards.map((innerItem) => (
                          <NewClaimsCard
                            data={innerItem}
                            onTap={() => this.props.history.push('/claims')}
                          />
                        ));
                    })}
                  </Session>
                )}
                {cards?.length > 0 && (
                  <Session>
                    <SectionHeading>Help</SectionHeading>
                    {cards?.map((item) => {
                      if (item.key === 'help') {
                        return item.cards.map((innerItem) => (
                          <NewHelpCard
                            data={innerItem}
                            onTap={() =>
                              this.getAppropriateRoute(innerItem.themeKey)
                            }
                          />
                        ));
                      }
                    })}
                  </Session>
                )}
                {showHospitalizationModal && (
                  <Modal>
                    <HospitalizationModalContainer
                      onClick={() =>
                        this.setState({ showHospitalizationModal: false })
                      }
                    >
                      <FadeInTransition
                        in={showPendingHospilationBlocker}
                        timeout={200}
                        mountOnEnter
                        unmountOnExit
                        onExited={this.hideModal}
                        appear
                      >
                        <div
                          ref={(node) => (this.node = node)}
                          className="bg-textbox flex flex-col items-center justify-center rounded-12"
                          style={{ width: '90%', maxWidth: '400px' }}
                        >
                          <HospitalizationModal
                            title={'Hospitalization'}
                            method1={'Claim Reimbursement'}
                            tag1={
                              'Get reimbursed for your previous hospitalisation'
                            }
                            method2={'Cashless Intimation Request'}
                            tag2={'Go cashless for your treatment'}
                            history={this.props.history}
                            showCashlessClaimButton={showCashlessClaimButton}
                            showReimbusementClaimButton={
                              showReimbusementClaimButton
                            }
                          />
                        </div>
                      </FadeInTransition>
                    </HospitalizationModalContainer>
                  </Modal>
                )}
              </div>
            </Body>
          </BodyContainer>
        )}
      </OuterContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  authToken: state.user.authToken,
  loginState: state.app.loginState,
  profileImage: state.user.profileImage,
  sponsorId: state.user.sponsorId,
  showSubscription: state.app.config.showSubscription,
  showOPD: state.app.config.showOPD,
  insured: state.app.config.insured,
  subscribed: state.app.config.subscribed,
});

const mapDispatchToProps = (dispatch) => ({
  openFileViewer: (content) => dispatch(openFileViewer(content)),
});

export default connect(mapStateToProps, mapDispatchToProps)(IpdBenefits);
